export default __webpack_public_path__ + "static/media/480_store04-es-mobile.452c8c86.png";